import React from 'react';
import './Landing.css';

const Landing = () => {
  const spotifyUrl = "https://open.spotify.com/album/5ylUVjLgvajEkatbl0wv5J?si=EQW-ar6KTp6j073PjluDYQ";
  const albumArtwork = "https://customer-assets.emergentagent.com/job_dark-theater-sesme/artifacts/jpmqneko_ISIMG-1089988.jpeg";

  return (
    <div className="landing-container">
      {/* Main content */}
      <main className="landing-content">
        {/* Album Artwork */}
        <div className="artwork-container">
          <img 
            src={albumArtwork} 
            alt="Face of an Angel - Album Artwork" 
            className="album-artwork"
          />
        </div>
        
        {/* Release Info */}
        <div className="release-info">
          <h1 className="release-title">Face of an Angel</h1>
          <p className="release-status">Out NOW</p>
        </div>
        
        {/* CTA Button */}
        <a 
          href={spotifyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="spotify-button"
        >
          LISTEN ON SPOTIFY
        </a>
        
        {/* Identity Line */}
        <div className="identity-section">
          <p className="artist-name">SESME</p>
          <p className="artist-tagline">Cinematic Hip-Hop.</p>
          <p className="artist-tagline">Stories from the shadows.</p>
        </div>
      </main>
    </div>
  );
};

export default Landing;
